// extracted by mini-css-extract-plugin
var _1 = "ListTableBodyCell_bodyCell__XzCMK";
var _2 = "ListTableBodyCell_center__eN4Qf";
var _3 = "ListTableBodyCell_left__Bc45P";
var _4 = "ListTableBodyCell_noPadding__87aBD";
var _5 = "ListTableBodyCell_right__3gpPF";
export { _1 as "bodyCell", _2 as "center", _3 as "left", _4 as "noPadding", _5 as "right" }
